module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product11-3203088cda72ef1dec9fb32449824899.jpg";